<div class="sidenav-hold">
  <div class="icon-menu mb-1" *ngIf="hasIconTypeMenuItem">
    <!-- Icon menu separator -->
    <div class="mb-1 nav-item-sep">
      <mat-divider [ngStyle]="{margin: '0 -24px'}"></mat-divider>
      <span class="text-muted icon-menu-title">{{iconTypeMenuTitle}}</span>
    </div>
    <!-- Icon menu items -->
    <div class="icon-menu-item" *ngFor="let item of orderedMenuItems">
      <button *ngIf="!item.disabled && item.type === 'icon'" mat-raised-button matTooltipClass="mat-tooltip-custom"
        matTooltip="{{item.tooltip}}" matTooltipPosition="below" routerLink="/{{item.state}}"
        routerLinkActive="mat-bg-primary">
        <mat-icon>{{item.icon}}</mat-icon>
      </button>
    </div>
  </div>

  <ul appDropdown class="sidenav">
    <li *ngFor="let item of orderedMenuItems" appDropdownLink [independentDropdown]="isSupplierPreviewMenu(item)" routerLinkActive="close" [class.kyc-locked-item]="isLocked(item)">
      <div class="nav-item-sep" *ngIf="item.type === 'separator'">
        <mat-divider></mat-divider>
        <span class="text-muted">{{item.name?item.name:'' | translate}}</span>

      </div>

      <div *ngIf="!item.disabled && item.type !== 'separator' && item.type !== 'icon'" class="lvl1">
        <a [routerLink]="isLocked(item) ? null : ('/' + item.state)" appDropdownToggle matRipple *ngIf="item.type === 'link'"
           (click)="handleMenuClick(item, $event)"
           [class.kyc-locked]="isLocked(item)"
           [matTooltip]="getTooltip(item)" matTooltipPosition="right">
          <mat-icon>{{item.icon}}</mat-icon>
          <!-- Inbox red dot badge in compact mode -->
          <span class="compact-badge-dot"
                *ngIf="isCompact && item.name === 'Inbox' && mailCount && mailCount[0]?.totalCount">
          </span>
          <span class="item-name lvl1">{{item.name?item.name:'' | translate}}
            <ng-container *ngIf="item.name === 'Inbox' && mailCount && mailCount[0] && mailCount[0].totalCount">
              ( {{mailCount[0].totalCount}} )
            </ng-container>
          </span>

          <span fxFlex></span>
          <mat-icon *ngIf="isLocked(item)" class="kyc-lock-icon">lock</mat-icon>
          <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}"
            *ngFor="let badge of item.badges">{{ badge.value }}</span>
        </a>
        <a [href]="isLocked(item) ? null : item.state" appDropdownToggle matRipple *ngIf="item.type === 'extLink'" target="_blank"
           [class.kyc-locked]="isLocked(item)"
           (click)="handleMenuClick(item, $event)"
           [matTooltip]="getTooltip(item)" matTooltipPosition="right">
          <mat-icon>{{item.icon}}</mat-icon>
          <span class="item-name lvl1">{{item.name?item.name:'' | translate}}</span>
          <span fxFlex></span>
          <mat-icon *ngIf="isLocked(item)" class="kyc-lock-icon">lock</mat-icon>
          <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}"
            *ngFor="let badge of item.badges">{{ badge.value }}</span>
        </a>

        <!-- DropDown: auto-expand sidebar when clicked in compact mode -->
        <a *ngIf="item.type === 'dropDown'" appDropdownToggle matRipple
           [matTooltip]="getTooltip(item)" matTooltipPosition="right"
           (click)="onDropdownClick()">
          <mat-icon>{{item.icon}}</mat-icon>
          <span class="item-name lvl1">{{item.name?item.name:'' | translate}}</span>
          <span fxFlex></span>
          <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}"
            *ngFor="let badge of item.badges">{{ badge.value }}</span>
          <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
        </a>
        <!-- LEVEL 2 -->
        <ul class="submenu lvl2" appDropdown *ngIf="item.type === 'dropDown'">
          <div style="overflow-y: scroll;max-height: 90px;">
              <li *ngFor="let itemLvL2 of item.sub" appDropdownLink routerLinkActive="open" [class.kyc-locked-item]="isLockedChild(itemLvL2)">
            <a [routerLink]="isLockedChild(itemLvL2) ? null : itemLvL2.state" appDropdownToggle
              *ngIf="itemLvL2.type !== 'dropDown'" matRipple
              [class.kyc-locked]="isLockedChild(itemLvL2)"
              (click)="handleSubMenuClick(itemLvL2, $event)"
              [matTooltip]="getTooltip(itemLvL2, true)" matTooltipPosition="right">
              <span class="item-name lvl2">{{itemLvL2.name | translate}}</span>
              <span fxFlex></span>
              <mat-icon *ngIf="isLockedChild(itemLvL2)" class="kyc-lock-icon">lock</mat-icon>
              <span *ngIf="isWarningNotification || isForceNotification">
                <span
                  [ngClass]="isWarningNotification ?'menuitem-badge mat-bg-accent': isForceNotification ? 'menuitem-badge mat-bg-warn' : ''"
                  class="menuitem-badge mat-bg-{{ badge.color }}" style="border-radius: 11px;"
                  *ngFor="let badge of itemLvL2.badges"></span>
              </span>
            </a>

            <a *ngIf="itemLvL2.type === 'dropDown'" appDropdownToggle matRipple>
              <span class="item-name lvl2">{{itemLvL2.name | translate}}</span>
              <span fxFlex></span>
              <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
            </a>

            <!-- LEVEL 3 -->
            <ul class="submenu lvl3" appDropdown *ngIf="itemLvL2.type === 'dropDown'">
              <li *ngFor="let itemLvL3 of itemLvL2.sub" appDropdownLink routerLinkActive="open" [class.kyc-locked-item]="isLockedChild(itemLvL3)">
                <a [routerLink]="isLockedChild(itemLvL3) ? null : itemLvL3.state"
                  appDropdownToggle matRipple
                  [class.kyc-locked]="isLockedChild(itemLvL3)"
                  (click)="handleSubMenuClick(itemLvL3, $event)"
                  [matTooltip]="getTooltip(itemLvL3, true)" matTooltipPosition="right">
                  <span class="item-name lvl3">{{itemLvL3.name | translate}}</span>
                  <span fxFlex></span>
                  <mat-icon *ngIf="isLockedChild(itemLvL3)" class="kyc-lock-icon">lock</mat-icon>
                </a>
              </li>
            </ul>

          </li>
          </div>
        </ul>
      </div>
    </li>
  </ul>
</div>

<!-- ===== Help Center slide-in panel (replaces the old "Help opens a PDF") ===== -->
<div class="help-backdrop" *ngIf="showHelpCenter" (click)="closeHelpCenter()"></div>
<aside class="help-panel" [class.open]="showHelpCenter" role="dialog" aria-modal="true" aria-label="Help Center">
  <header class="help-panel__head">
    <button class="help-close" type="button" (click)="closeHelpCenter()" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
    <div class="help-eyebrow"><mat-icon>support_agent</mat-icon><span>Help Center</span></div>
    <h3>How can we help?</h3>
    <span class="help-sub">Guides, support &amp; what's new — all in one place</span>
  </header>

  <div class="help-search"><mat-icon>search</mat-icon><span>Search help topics…</span></div>

  <div class="help-scroll">
    <div class="help-group">Documentation</div>
    <div class="help-body">
      <button class="help-card" type="button" (click)="openUserManual()">
        <span class="help-ico"><mat-icon>menu_book</mat-icon></span>
        <span class="help-txt"><b>User Manual</b><small>Role-based PDF guide</small></span>
        <mat-icon class="help-go">chevron_right</mat-icon>
      </button>
      <button class="help-card" type="button" (click)="openFaqs()">
        <span class="help-ico"><mat-icon>quiz</mat-icon></span>
        <span class="help-txt"><b>FAQs</b><small>Quick answers to common questions</small></span>
        <mat-icon class="help-go">open_in_new</mat-icon>
      </button>
      <button class="help-card" type="button" (click)="openVideoTutorials()">
        <span class="help-ico"><mat-icon>play_circle</mat-icon></span>
        <span class="help-txt"><b>Video Tutorials</b><small>Watch the product demo video</small></span>
        <mat-icon class="help-go">open_in_new</mat-icon>
      </button>
    </div>

    <div class="help-group">Support</div>
    <div class="help-body">
      <button class="help-card" type="button" (click)="openAiAssistant()">
        <span class="help-ico"><mat-icon>smart_toy</mat-icon></span>
        <span class="help-txt"><b>Ask the AI Assistant</b><small>Instant answers from your in-app assistant</small></span>
        <mat-icon class="help-go">chevron_right</mat-icon>
      </button>
      <button class="help-card" type="button" (click)="openContactSupport()">
        <span class="help-ico"><mat-icon>mail</mat-icon></span>
        <span class="help-txt"><b>Contact Support</b><small>Raise a ticket with our support team</small></span>
        <mat-icon class="help-go">chevron_right</mat-icon>
      </button>
    </div>
  </div>

  <div class="help-panel__foot">
    <span>VS-MPS Help</span>
    <button class="help-foot-link" type="button" (click)="helpComingSoon('What\'s New')">What's new</button>
  </div>
</aside>
